export const STEPS = {
    PATIENT: "patient",
    PRESCRIPTION: "prescription",
    MEDICINES: "medicines",
    QUOTE: "quote",
};

export const STEP_ORDER = [STEPS.PATIENT, STEPS.PRESCRIPTION, STEPS.MEDICINES, STEPS.QUOTE];

export const STEP_LABELS = {
    [STEPS.PATIENT]: "Patient",
    [STEPS.PRESCRIPTION]: "Prescription",
    [STEPS.MEDICINES]: "Medicines",
    [STEPS.QUOTE]: "Quotation",
};

export const LINE_STATUS = {
    MATCHED: "matched",
    CHOOSE: "choose",
    UNMATCHED: "unmatched",
};

/**
 * Per-status presentation. The rail colour is the fastest read on a long list,
 * so it carries the state on its own — the label repeats it for anyone who
 * can't rely on colour.
 */
export const STATUS_STYLES = {
    [LINE_STATUS.MATCHED]: {
        rail: "bg-elm-500",
        chip: "bg-elm-50 text-elm-700 border-elm-200",
        label: "Matched",
    },
    [LINE_STATUS.CHOOSE]: {
        rail: "bg-amber-400",
        chip: "bg-amber-50 text-amber-700 border-amber-200",
        label: "Needs a choice",
    },
    [LINE_STATUS.UNMATCHED]: {
        rail: "bg-rose-400",
        chip: "bg-rose-50 text-rose-700 border-rose-200",
        label: "No match",
    },
};

export const SLOTS = [
    { key: "morning", short: "M", label: "Morning" },
    { key: "afternoon", short: "A", label: "Afternoon" },
    { key: "evening", short: "E", label: "Evening" },
    { key: "night", short: "N", label: "Night" },
];

/**
 * Starting routine for a medicine the pharmacist adds by hand. OCR supplies a
 * routine for the lines it read; an added line has none, so it starts on a
 * one-a-day month and is refined downstream in the quotation editor, where full
 * routine editing already lives.
 *
 * `days` and `relationToFood` are left off deliberately — both are optional to
 * the quotation API, and guessing a food timing would be worse than saying
 * nothing.
 */
export const DEFAULT_ADDED_ROUTINE = {
    schedule: { morning: 1, afternoon: 0, evening: 0, night: 0 },
    doseSize: 1,
    frequency: "everyday",
    duration: 30,
};

export const ACCEPTED_FILE_TYPES = "image/jpeg,image/jpg,image/png,application/pdf";

export const MAX_FILE_SIZE_MB = 5;
